<div
  echarts
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
  [autoResize]="true"
  (chartInit)="onChartInit($event)"
  (chartClick)="onChartClick($event)"
  class="box-plot-chart"
  [class.box-plot-chart--explain]="explainMode()"
></div>
